import { userInfoKeys } from '~domains/auth/api/user-info-keys';

import { useQuery } from '@tanstack/react-query';

import { getUserInfo } from './get-user-info';

import { isNewUser } from '../lib';
import type { UserInfo } from '../model';

export const fetchUserInfoWithRole = async (): Promise<UserInfo> => {
  const userInfo = await getUserInfo();
  if (isNewUser(userInfo)) {
    throw new Error('User does not have the role');
  }
  return userInfo;
};

export const useWaitUserInfoWithRole = ({
  retry,
  retryDelay,
}: {
  retry?: number;
  retryDelay?: number;
}) =>
  useQuery({
    queryKey: userInfoKeys.all(),
    queryFn: fetchUserInfoWithRole,
    gcTime: 0,
    retry,
    retryDelay,
    meta: {
      skipGlobalErrorHandling: true,
    },
  });
